import UserConfigurationManagementPage from '../pages/UserConfigurationManagementPage'

const routes = [
    { name: 'UserConfigurationManagementPage', path: '/user-configuration-management', component: UserConfigurationManagementPage, meta: { requiresAuth: true, permission: 'USER_CONFIGURATION_SHOW' } },
]

export default routes;

